import { Link, useLocation } from 'react-router-dom'
import { Box, ListItemButton, ListItemText } from '@mui/material'
import useLocationHelpers from '@/hooks/useLocationHelpers'
import { SUPER_USER_ONLY_COLOR } from '@/theme/usePixydocsTheme'

export type SettingsNavigationItemProps = {
  label: string
  to: string
  isSuperUserOnly?: boolean
  keepQueryParams?: boolean
  persistentBarColor?: string
}

export default function SettingsNavigationItem({
  label,
  to,
  isSuperUserOnly,
  keepQueryParams,
  persistentBarColor,
}: SettingsNavigationItemProps) {
  const { pathname } = useLocation()
  const { appendCurrentParamsToUrl } = useLocationHelpers()
  const selected = to.includes('/')
    ? pathname.endsWith(to)
    : pathname.split('/').includes(to)

  return (
    <Box
      sx={{
        position: 'relative',
        '&:before': {
          content: selected || persistentBarColor ? '""' : undefined,
          position: 'absolute',
          top: 4,
          left: -8,
          width: 4,
          height: 'calc(100% - 8px)',
          background: (theme) =>
            persistentBarColor || theme.palette.primary.main,
          borderRadius: 2,
          opacity: 0.3,
        },
      }}
    >
      <ListItemButton
        component={Link}
        to={keepQueryParams ? appendCurrentParamsToUrl(to) : to}
        selected={selected}
        sx={{
          borderRadius: 2,
          py: 0.5,
          px: 1.5,
          color: isSuperUserOnly ? SUPER_USER_ONLY_COLOR : undefined,
        }}
      >
        <ListItemText primary={label} color="primary" />
      </ListItemButton>
    </Box>
  )
}
